import script from "./AccountForwardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountForwardComponent.vue?vue&type=script&setup=true&lang=js"

import "./AccountForwardComponent.vue?vue&type=style&index=0&id=a6d5c7aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6d5c7aa"]])

export default __exports__